import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ProductCategory6 = () => {
const specifications = [
    {
      title: "80-150",
      subtitle: "Thickness (gsm)",
      icon: "📏"
    },
    {
      title: "250-650", 
      subtitle: "Height (mm)",
      icon: "📐"
    },
    {
      title: "230-450",
      subtitle: "Width (mm)", 
      icon: "↔️"
    },
    {
      title: "80-220",
      subtitle: "Gusset (mm)",
      icon: "📦"
    },
    {
      title: "Six",
      subtitle: "Color Options",
      icon: "🎨"
    }
  ];

  return (
    <div className="container py-5">
      {/* Header */}
      <div className="row">
        <div className="col-12 text-center mb-4">
          <h2 className="main-heading display-5 fw-bold mb-3" style={{ 
            // fontSize: '1rem',
            // fontWeight: '500',
            // color: '#333',
            // letterSpacing: '0.5px'
          }}>
            Specifications
          </h2>
        </div>
      </div>
      
      {/* Specifications Row */}
      <div className="row">
        {specifications.map((spec, index) => (
          <div key={index} className="col">
            <div className="text-center">
              {/* Main Value */}
              <h2 className="mb-1" style={{
                fontSize: '2.5rem',
                fontWeight: '300',
                color: '#333',
                lineHeight: '1'
              }}>
                {spec.title}
              </h2>
              
              {/* Subtitle */}
              <p className="mb-3" style={{
                fontSize: '0.75rem',
                color: '#666',
                fontWeight: '400',
                margin: '0',
                lineHeight: '1.2'
              }}>
                {spec.subtitle}
              </p>
              
              {/* Icon Circle */}
              <div className="d-flex justify-content-center mb-2">
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  border: '1px solid #ddd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  backgroundColor: '#fff'
                }}>
                  {spec.icon}
                </div>
              </div>
              
              {/* Bottom text - Paper bag related */}
              <p style={{
                fontSize: '0.7rem',
                color: '#999',
                margin: '0',
                fontWeight: '400'
              }}>
                Paper bag specs
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductCategory6 ;